export const updateQueryParams = (newParams: any, _setSearchParams: any) => {
  _setSearchParams((prevParams) => {
    const updatedParams = new URLSearchParams(prevParams);
    Object.entries(newParams).forEach(([key, value]) => {
      updatedParams.set(key, String(value));
    });
    return updatedParams;
  });
};

export const getQueryParam = (param: any) => {
  const searchParams = new URLSearchParams();
  return searchParams.get(param);
};

export const deleteQueryParam = (param: any, _setSearchParams: any) => {
  _setSearchParams((prevParams) => {
    const updatedParams = new URLSearchParams(prevParams);
    updatedParams.delete(param);
    return updatedParams;
  });
};
